export const CUSTOM_EVENTS = {
  CHANGE_API_VERSION: 'native:changeApiVersion',
  LOGOUT_ACTION: 'native:logoutAction',
  ORDER_IMPORT_ACTION: 'native:orderImportAction',
  FILE_GENERATOR_NOTIFICATION: 'native:FileGeneratorNotification',
};
